import React from "react";
import { useLanguage } from "../context/LanguageContext";

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="portfolio-footer">
      © {new Date().getFullYear()} Ahmada - {t("footerRights")}
    </footer>
  );
}

export default Footer;
